import type {
  CourseStructureSchemaType,
  CourseStructureFontSchemaType,
} from '@vedalib/editor/lib/brand'
import type { CourseStructureElementValue, CourseStructureItem } from '@vedalib/editor/lib/elements'

import type { ISectionTreeNode } from 'components/sections/ProjectStructure/utils'
import Collapse from 'components/uiKit/Collapse'
import type { ElementStyleCss, ElementFontCss } from 'services/Branding/types'
import type { Section } from 'services/Store/Project/types'

import * as s from './CourseStructureTree.module.scss'
import { StructureNodeElement } from './components/StructureNodeElement'

interface IStructureCollapse {
  nodes: ISectionTreeNode<CourseStructureItem>[]
  onSectionPick: (sectionId: string) => void
  section?: Section | null
  value: CourseStructureElementValue
  styles: ElementStyleCss<CourseStructureSchemaType>
  font: ElementFontCss<CourseStructureFontSchemaType>
  sections: Section[]
  getDisabledSection: (id: string) => boolean
  getSectionProgress: (id: string) => number
}

const CourseStructureTree: React.FC<IStructureCollapse> = ({
  nodes,
  onSectionPick,
  section,
  value,
  font,
  styles,
  sections,
  getSectionProgress,
  getDisabledSection,
}) => (
  <ul className={s.tree}>
    {nodes.map((node) => (
      <li key={node.item.id}>
        {node.children?.length ? (
          <Collapse
            collapsible='icon'
            header={(props) => (
              <StructureNodeElement
                {...props}
                font={font}
                getDisabledSection={getDisabledSection}
                getSectionProgress={getSectionProgress}
                node={node}
                sections={sections}
                styles={styles}
                value={value}
              />
            )}
            initialOpen={value.initialOpen}
            key={node.item.id}
            name={node.item.name || node.item.id}
            styleType='ghost'
          >
            <CourseStructureTree
              font={font}
              getDisabledSection={getDisabledSection}
              getSectionProgress={getSectionProgress}
              nodes={node.children}
              onSectionPick={onSectionPick}
              section={section}
              sections={sections}
              styles={styles}
              value={value}
            />
          </Collapse>
        ) : (
          <StructureNodeElement
            font={font}
            getDisabledSection={getDisabledSection}
            getSectionProgress={getSectionProgress}
            key={node.item.id}
            node={node}
            onClick={() => onSectionPick(node.item.id)}
            sections={sections}
            styles={styles}
            value={value}
            open
          />
        )}
      </li>
    ))}
  </ul>
)

export default CourseStructureTree
